import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
  Table,
  CardText,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import SeasonAction from "store/season-resource/actions"
import RtwInventoryAction from "store/rtw-inventory/actions"
import TableContainer from "components/tables/TableContainer"

export default function DetailRtwInventoryManagement() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      number: "string",
      supplierName: "string",
      year: 0,
      seasonName: "string",
      numberOfOrders: 0,
      currentlyInProduction: 0,
      actualInventory: 0,
      theoreticalStock: 0,
      needRestock: true,
      qtyAdjustment: 0,
      orderHistories: [
        {
          orderDate: "2023-04-03",
          orderNumber: "string",
          qty: 0,
        },
      ],
    },
    validationSchema: Yup.object({
      // name: Yup.string().required('必須項目です。'),
      // code: Yup.string().required('必須項目です。').min(0).max(2),
    }),
    onSubmit: values => {
      dispatch(
        RtwInventoryAction.putData(
          {
            qtyAdjustment: values.qtyAdjustment,
            productId: params.productId,
            size: params.size,
          },
          callbackPut
        )
      )
    },
  })

  const callbackPost = () => {
    history.push("/inventory-control/rtw-inventory-management")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/inventory-control/rtw-inventory-management")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(
        RtwInventoryAction.getDetail(
          { productId: params.productId, size: params.size },
          callbackGetDetail
        )
      )
    }
  }, [params.productId, params.size])

  return (
    <>
      <MetaTags>
        <title>RTW在庫商品詳細 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="RTW在庫商品詳細" breadcrumbList={[]} />

          <Card body>
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <Col sm="3">
                  <Label>商品番号</Label>
                  <Input value={validation.values.number} disabled />
                </Col>
                <Col sm="3">
                  <Label>お取引先</Label>
                  <Input value={validation.values.supplierName} disabled />
                </Col>
                <Col sm="3">
                  <Label>年度</Label>
                  <Input value={validation.values.year} disabled />
                </Col>
                <Col sm="3">
                  <Label>シーズン</Label>
                  <Input value={validation.values.seasonName} disabled />
                </Col>
                <Col sm="3" className="mt-3">
                  <Label>サイズ</Label>
                  <Input value={params.size} disabled />
                </Col>

                <Col sm="12" className="mt-3">
                  <Table bordered striped>
                    <thead>
                      <tr>
                        <td>実在個数</td>
                        <td>引き当て</td>
                        <td>理論在庫</td>
                        <td>受注済数</td>
                        <td>数量調整</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{validation.values.actualInventory}</td>
                        <td>{validation.values.currentlyInProduction}</td>
                        <td>▲ {validation.values.theoreticalStock}</td>
                        <td>{validation.values.currentlyInProduction}</td>
                        <td>
                          <Input
                            name="qtyAdjustment"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.qtyAdjustment || ""}
                            invalid={
                              validation.errors.qtyAdjustment ? true : false
                            }
                          />
                          {validation.errors.qtyAdjustment ? (
                            <FormFeedback type="invalid">
                              {validation.errors.qtyAdjustment}
                            </FormFeedback>
                          ) : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>

                <Col sm="12" className="d-flex justify-content-end mt-2">
                  <Button type="submit" className="button">
                    保存
                  </Button>

                  <Button
                    type="button"
                    className="ms-2 button"
                    onClick={() =>
                      history.push(
                        "/inventory-control/rtw-inventory-management"
                      )
                    }
                  >
                    キャンセル
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
          <Card body>
            <CardText>引き当て在庫</CardText>
            {store.fabricInventory.detail.loading ? (
              <LoadingComponent />
            ) : (
              <TableContainer
                data={validation.values.orderHistories || []}
                columns={[
                  {
                    Header: "日付",
                    accessor: "orderDate",
                    defaultCanSort: false,
                  },
                  {
                    Header: "受注番号",
                    accessor: "orderNumber",
                    defaultCanSort: false,
                  },
                  {
                    Header: "数量",
                    accessor: "qty",
                    defaultCanSort: false,
                  },
                ]}
              />
            )}
          </Card>
        </Container>
      </div>
    </>
  )
}
